<div class="card-box-medium margin-right-small">
    <h3>Estudios realizados</h3>
    <mat-divider></mat-divider>
    <mat-spinner *ngIf="loading"></mat-spinner>
    <table *ngIf="!loading" class="table-content margin-top-medium">
        <tr>
            <th>Práctica</th>
            <th>Centro</th>
            <th>Estado</th>
            <th>Fecha</th>
            <th></th>
        </tr>

        <tr *ngFor="let practiceRegion of practiceRegions">
            <td>{{ practiceRegion.PracticeRegionName }}</td>
            <td>{{ getCenterName( practiceRegion.InvoicingCenterId ) }}</td>
            <td>{{ getBillingStateName( practiceRegion.InvoicingStateId ) }}</td>
            <td>{{ practiceRegion.InvoicingDate | date:'dd/MM/yyyy' }}</td>
            <td> <button type="button" (click)="edit(practiceRegion)" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button> </td>
        </tr>
    </table>

    <table *ngIf="!loading && practiceRegionAditionals.length > 0" class="table-content margin-top-large">
        <tr>
            <th>Práctica adicional</th>
            <th>Centro</th>
            <th>Estado</th>
            <th>Fecha</th>
            <th></th>
        </tr>

        <tr *ngFor="let practiceRegion of practiceRegionAditionals">
            <td>{{ practiceRegion.PracticeRegionAditionalName }}</td>
            <td>{{ getCenterName( practiceRegion.InvoicingCenterId ) }}</td>
            <td>{{ getBillingStateName( practiceRegion.InvoicingStateId ) }}</td>
            <td>{{ practiceRegion.InvoicingDate | date:'dd/MM/yyyy' }}</td>
            <td> <button type="button" (click)="edit(practiceRegion)" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button> </td>
        </tr>
    </table>

    <table *ngIf="!loading && setSupplies.length > 0" class="table-content margin-top-large">
        <tr>
            <th>Set insumo</th>
            <th>Centro</th>
            <th>Estado</th>
            <th>Fecha</th>
            <th></th>
        </tr>

        <tr *ngFor="let setSupplie of setSupplies">
            <td>{{ setSupplie.SetSupplieName }}</td>
            <td>{{ getCenterName( setSupplie.InvoicingCenterId ) }}</td>
            <td>{{ getBillingStateName( setSupplie.InvoicingStateId ) }}</td>
            <td>{{ setSupplie.InvoicingDate | date:'dd/MM/yyyy' }}</td>
            <td> <button type="button" (click)="edit(setSupplie)" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button> </td>
        </tr>
    </table>
</div>
<div class="card-box-medium">
    <h3>Profesionales actuantes e informantes</h3>
    <mat-divider></mat-divider>
</div>